import { useFormikContext } from 'formik';
import React from 'react';

import { Select } from '@candu-ai/analytics/ui';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

interface Props {
  name: string;
  base: string;
  readOnly?: boolean;
}

const options = [
  {
    // this is a little confusing, but it's a double negative
    value: 'false',
    label: 'Users are in',
  },
  {
    value: 'true',
    label: "Users aren't in",
  },
];

export const InOrNotSelector = ({ name, readOnly }: Props) => {
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  return (
    <Select
      name={name}
      values={values}
      selectFirstByDefault
      InputWrapper={SelectInputWrapper}
      options={options}
      readOnly={readOnly}
      setFieldValue={setFieldValue}
      validateOnSelectWithErrors
    />
  );
};
